import { Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { NavParams, LoadingController, ModalController } from '@ionic/angular';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { GUIService } from '../../gui.service';
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage } from 'ngx-elvis-ds';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { I18NService } from 'src/app/services/i18n.service';

export class ProductDetailDialogCommands {
  public static OPEN = ['CMD_ITEM_INFO_OPEN'];
  public static UPDATE = [];
  public static CLOSE = [];
}

@Component({
  selector: 'app-product-detail-dialog',
  templateUrl: './product-detail-dialog.page.html',
  styleUrls: ['./product-detail-dialog.page.scss'],
})
export class ProductDetailDialogPage extends BasePage implements OnInit {

  @ViewChild('productDetailDialog', { static: true }) pdfViewerDialog: ElementRef;
  @Input() data: any;

  filename: string;
  pageURL: SafeResourceUrl;
  
  constructor(
    public config: ConfigService,
    public themeSvc: ThemeService,
    public guiSvc: GUIService,
    private sanitizer: DomSanitizer,
    private modalCtrl: ModalController,
    public i18nSvc: I18NService
  ) {
    super();
  }

  ngOnInit() {
    // let assetBase = 'http://xcloud.xpos.host:8080';

    // if (this.config.assetsSettings) {
    //   assetBase = this.config.assetsSettings.address;
    // }

    // this.filename = this.data.Filename;
    if (this.data.url) {
      this.pageURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
    } else {
      this.modalCtrl.dismiss();
    }
  }

  onDismiss() {
    this.modalCtrl.dismiss();
  }
}
